class FooterMenuAccordion extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    if (!this.details) return;
    this.handleBreakpointChange();
    this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
    this.details.addEventListener('toggle', this.handleToggle);
  }

  disconnectedCallback() {
    if (!this.details) return;
    this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
    this.details.removeEventListener('toggle', this.handleToggle);
  }

  handleBreakpointChange() {
    this.details.open = this.mediaQuery.matches;
    this.handleToggle();
  }

  handleToggle() {
    if (!this.summary) return;
    this.summary.setAttribute('aria-expanded', this.details.open);
  }
}

if (!customElements.get('footer-menu-accordion')) {
  customElements.define('footer-menu-accordion', FooterMenuAccordion);
}
